import React from 'react'

const AwardsIcon = () => {
  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
      <path
        d="M9.91663 2.83301H24.0833V13.9538C24.0833 14.4969 23.9652 14.9809 23.7291 15.4059C23.493 15.8309 23.1625 16.1733 22.7375 16.433L17.7083 19.408L18.7 22.6663H24.0833L19.6916 25.783L21.3916 31.1663L17 27.8372L12.6083 31.1663L14.3083 25.783L9.91663 22.6663H15.3L16.2916 19.408L11.2625 16.433C10.8375 16.1733 10.5069 15.8309 10.2708 15.4059C10.0347 14.9809 9.91663 14.4969 9.91663 13.9538V2.83301ZM12.75 5.66634V13.9538L15.5833 15.6538V5.66634H12.75ZM21.25 5.66634H18.4166V15.6538L21.25 13.9538V5.66634Z"
        fill="#CCCFD6"
      />
    </svg>
  )
}

export default AwardsIcon
